const { DateTime } = require("luxon");

/**
 *
 * Find if a page has restricted access with available static data
 *
 * @param restricted: Restricted boolean on/off
 * @param scheduled: Time when page stops being restricted
 **/

module.exports = function findIfRestrictedStatic({ restricted, scheduled }) {
	// Set time related variables
	const nowStr = DateTime.now().toUTC().toISO();
	const scheduledTimeStr = typeof scheduled === "string" ? scheduled : null;
	const now = DateTime.fromISO(nowStr);
	const scheduledTime = scheduledTimeStr ? DateTime.fromISO(scheduledTimeStr) : null;
	//if scheduled publication time was specified, check if we're pass that time
	const restrictedByTime = scheduledTime ? now < scheduledTime : false;
	//set restriction status based on time if any or just the restricted checkmark
	if (restricted) {
		if (!scheduledTime) {
			//if no scheduled time, it's always restricted
			return 1;
		} else if (scheduledTime && restrictedByTime) {
			//if scheduled time and we're before it, it's restricted
			return 2;
		} else if (scheduledTime) {
			return 0;
		}
	}

	return null;
};
